import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import settings from '../public/settings.json';
import store from './store'
import axios from 'axios'
import 'regenerator-runtime/runtime'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import tinymce from "vue-tinymce-editor";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
Vue.component("tinymce", tinymce);


import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "../assets/css/pagebreak.css"
  ]
};
Vue.use(VueHtmlToPaper, options);




Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");


Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)



const baseAPI = axios.create({
  baseURL: settings.apiURL,
});

const UNAUTHORIZED = 401;


Vue.mixin({
  methods: {
    GetBaseUrl() {
      return settings.apiURL;
    },
    UserAuth() {
      return this.$API
        .get(this.$UserAuth, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 202) {
            return true;
          } else
            return false;
        });
    },
    GetInfoUser() {
      this.$API
        .get(this.$LoginUserDetail, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          console.log("t" + this.info);

          if (response.status == 200 && this.info != null) {
            this.Name = this.info.name;
            console.log("t" + this.info.name);
          
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            this.Error = true;
            this.Message = error;
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
   

    // GoToLogin() {
    //   let path = this.$router.currentRoute.path;
    //   if (path.toLowerCase() != "/login") {

    //     this.$router.push({
    //       path: '/Login',
    //       query: {
    //         targetUrl: this.$router.currentRoute.fullPath,
    //       }
    //     })

    //   }
    // },
    GoToSignUp() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/index") {
        this.$router.push("/Index");
      }
    },
    GoToHome() {
      this.$router.push("/Index");
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.$router.push("/");
          }
        });

    },

    googleTranslateElementInit() {
      window.google.translate.TranslateElement(
        { pageLanguage: "en" },
        "google_translate_element"
      );
    },
  }

})

baseAPI.interceptors.response.use(response => response, error => {
  const {
    status
  } = error.response;
  if (status == UNAUTHORIZED) {
    router.push("/Login");
  } else {
    console.log("test");
  }
  return Promise.reject(error);
  //
})



Vue.prototype.$API = baseAPI

Vue.prototype.$uploadFile = 'aws/UploadVideoSessionIndex'
Vue.prototype.$uploadDocument = 'aws/UploadDocumentUser'
Vue.prototype.$UploadProfilePhoto = 'aws/UploadProfilePhoto'
Vue.prototype.$UploadBlog = 'aws/UploadBlog'
Vue.prototype.$UploadBlogFile = 'aws/UploadBlogFile'
Vue.prototype.$UploadBannerVoucher = 'aws/UploadBanner'
Vue.prototype.$UploadFlag = 'aws/UploadFlag'
Vue.prototype.$UploadVideoCreativeInsight = 'aws/UploadVideoCreativeInsight'

//update
Vue.prototype.$DeleteSession = 'update/DeleteSession'
Vue.prototype.$UpdatePaymentPackage = 'kiddo/update/UpdatePaymentPurchase'
Vue.prototype.$UpdateCompanyView = 'update/UpdateCompanyView'
Vue.prototype.$CompanyDetail = 'update/CompanyDetails'
Vue.prototype.$UserDetails = 'update/UserDetails'
Vue.prototype.$ValidateEmail = 'update/VerifyEmail'
Vue.prototype.$UpdateComUpdateQuestionDetailpanyView = 'update/UpdateQuestionDetailCompanyView'
Vue.prototype.$UpdateDetailQuestionCode = 'update/UpdateDetailQuestionCode'
Vue.prototype.$UpdateBlog = 'update/UpdateBlog'
Vue.prototype.$UpdateUserCountry ='update/UpdateUserCountry'
Vue.prototype.$DeleteVideoCodeSession ='update/DeleteSession'
Vue.prototype.$UpdateUserFeature ='update/UpdateUserFeature'
Vue.prototype.$UpdateUserFeatureDirect ='update/UpdateUserFeatureDirect'
Vue.prototype.$UpdateVoucherControlView ='update/UpdateVoucherControlView'


//insert
Vue.prototype.$Register = 'kiddo/Insert/Register'
Vue.prototype.$LoginToken = 'kiddo/Insert/Login'
Vue.prototype.$UserAuth = 'kiddo/Insert/IsAuthenticated'
Vue.prototype.$ExtractAudioText = 'insert/ExtractAudioText'
Vue.prototype.$ForgotPassword = 'insert/ForgotPassword'
Vue.prototype.$ValidateForgotPasswordCode = 'insert/ValidateForgotPasswordCode'
Vue.prototype.$ChangePassword = 'insert/ChangePassword'
Vue.prototype.$InsertSession = 'insert/SetSessionByToken'
Vue.prototype.$RegisterInterest = 'insert/RegisterInterest'
Vue.prototype.$RegisterSupport = 'insert/RegisterSupport'
Vue.prototype.$InsertQuestionGeneral = 'insert/InsertQuestionGeneral'
Vue.prototype.$InsertNextQuestion = 'insert/InsertNextQuestion'
Vue.prototype.$SubmitCompanyQuestion = 'insert/SubmitCompanyQuestion'
Vue.prototype.$InsertVoucher = 'insert/InsertVoucher'
Vue.prototype.$InsertShorlistedCandidate = 'insert/InsertShorlistedCandidate'
Vue.prototype.$ChangePasswordWoCode = 'insert/ChangePasswordWoCode'
Vue.prototype.$GenerateReport = 'insert/GenerateRank'
Vue.prototype.$SubmitFeedbacks = 'insert/AppFeedback'
Vue.prototype.$SubscribePackage = 'kiddo/insert/PurchaseProduct'
Vue.prototype.$SubscribePackage_AutoRegister = 'kiddo/insert/PurchaseProduct_AutoRegister'
Vue.prototype.$SubscribePackageFree = 'kiddo/insert/PurchaseProductFree'
Vue.prototype.$SubscribePackageVisa = 'kiddo/insert/SubscribePackageVisa'
Vue.prototype.$ForgotPassword = 'insert/ForgotPassword'
Vue.prototype.$ChangePassword = 'insert/ChangePassword'
Vue.prototype.$SignOut = 'kiddo/insert/signout'
Vue.prototype.$RegisterSupport = 'insert/RegisterSupport'
Vue.prototype.$SetStatus = 'insert/SetStatus'
Vue.prototype.$EnterpriseContact = 'insert/EnterpriseContact'
Vue.prototype.$EvaluationCategory = 'insert/EvaluationCategory'
Vue.prototype.$SubmitVoucher = 'insert/InsertCustomVoucher'
Vue.prototype.$InsertCounterWebsite = 'insert/InsertCounterWebsite'
Vue.prototype.$InsertNewDataPosition = 'insert/InsertNewDataPosition'
Vue.prototype.$SendEmailAI = 'insert/SentEmailWaitingReport'
Vue.prototype.$RegisterNewStudent = 'kiddo/insert/RegisterNewStudent'
Vue.prototype.$InsertRegisterAffiliate = 'kiddo/insert/RegisterAffiliate'
Vue.prototype.$SetBankDetails = 'kiddo/insert/SetBankDetails'


//read
Vue.prototype.$LoginUserDetail = 'kiddo/Read/LoginUserDetailWebs'
Vue.prototype.$LoginUserDetailWoLogin = 'kiddo/Read/LoginUserDetail'
Vue.prototype.$GetFirstQuestion = 'read/GetFirstQuestion'
Vue.prototype.$GetNextQuestion = 'read/GetNextQuestion'
Vue.prototype.$GetUserHistory = 'read/GetUserHistory'
Vue.prototype.$GetListPosition = 'read/GetListPosition'
Vue.prototype.$GetListCountries = 'read/getlistcountries'
Vue.prototype.$GetNextQuestionVideo = 'read/GetVideoDetails'
Vue.prototype.$GetListUserHistory = 'read/GetListUserHistory'
Vue.prototype.$GetListPackageCandidate = 'read/GetListPackageCandidate'
Vue.prototype.$GetListPackageCompany = 'read/GetListPackageCompany'
Vue.prototype.$GetSuccessPaymentSubscription = 'read/GetSuccessPackageSubscriptionByUser'
Vue.prototype.$GetListSuccessPackageSubscription = 'read/GetListSuccessPackageSubscription'
Vue.prototype.$GetRank = 'read/GetRank'
Vue.prototype.$GetlistUser = 'read/GetListUsers'
Vue.prototype.$GetListReportNotGenerate = 'read/GetListReportNotGenerate'
Vue.prototype.$GetPackageCandidateById = 'read/GetPackageById'
Vue.prototype.$GetListVoucher = 'read/GetListVoucher'
Vue.prototype.$GetListContactUs = 'read/GetContactUs'
Vue.prototype.$SessionSummary = 'read/SessionSummary'
Vue.prototype.$GetVoucherAmount = 'read/GetVoucherAmount'
Vue.prototype.$GetListUserNotListedShortlisted = 'read/GetListUserNotListedShortlisted'
Vue.prototype.$GetListUserListedShortlisted = 'read/GetListUserListedShortlisted'
Vue.prototype.$SubscribePackageByUser = 'read/SubscribePackageByUser'
Vue.prototype.$GetDetailTotalCandidate = 'read/GetDetailTotalCandidate'
Vue.prototype.$GetTotalCandidate = 'read/GetTotalCandidate'
Vue.prototype.$GetSessionUrl = 'read/GetSessionUrl'
Vue.prototype.$GetSessionId = 'read/GetSessionId'
Vue.prototype.$GetListCategoryJob = 'read/GetListCategoryJob'
Vue.prototype.$GetListCategoryJobType = 'read/GetListCategoryJobType'
Vue.prototype.$GetListCategoryJobSeniority = 'read/GetListCategoryJobSeniority'
Vue.prototype.$GetQuestionAnswer = 'read/GetQuestionAnswer'
Vue.prototype.$GetFirstQuestionByCode = 'read/GetFirstQuestionByCode'
Vue.prototype.$GetFirstQuestionByQrCode = 'read/GetFirstQuestionByQrCode'
Vue.prototype.$GetNextQuestionByCode = 'read/GetNextQuestionByCode'
Vue.prototype.$GetTokenEmail = 'Read/GetTokenEmail'
Vue.prototype.$GetListField = 'read/GetListField'
Vue.prototype.$GetListExpertise = 'read/GetListExpertise'
Vue.prototype.$ListVideo = 'read/ListVideo'
Vue.prototype.$VerifyCode = 'read/VerifyCode'
Vue.prototype.$ListCreatedQuestion = 'read/ListCreatedQuestion'
Vue.prototype.$ListCreatedQuestionByid = 'read/ListCreatedQuestionByid'
Vue.prototype.$ListPackage = 'read/ListPackage'
Vue.prototype.$ListVoucher = 'read/ListVoucher'
Vue.prototype.$CheckQuestionCompanyCode = 'read/CheckQuestionCompanyCode'
Vue.prototype.$ListCodeInterviewr = 'read/ListCodeInterviewr'
Vue.prototype.$ListStatus ='read/ListStatus'
Vue.prototype.$ListAllBlog ='read/ListAllBlog'
Vue.prototype.$BlogPostById ='read/BlogPostById'
Vue.prototype.$ListPublishBlog ='read/ListPublishBlog'
Vue.prototype.$GetSubscription ='read/GetSubscription'
Vue.prototype.$GetValueDashboard ='read/GetValueDashboard'
Vue.prototype.$CheckVideoSessionIndex= 'read/CheckVideoSessionIndex'
Vue.prototype.$DataEvaluation= 'read/DataEvaluation'
Vue.prototype.$DataEvalutionCompany='read/DataEvalutionCompany'
Vue.prototype.$GetTotalUserHistory='read/GetTotalUserHistory'
Vue.prototype.$TotalNotListedShortlisted='read/TotalNotListedShortlisted'
Vue.prototype.$TotalNotListedShortlistedByUserId='read/TotalNotListedShortlistedByUserId'
Vue.prototype.$AskAI='read/AskAI'
Vue.prototype.$GetVoucherById = 'read/GetVoucherById'
Vue.prototype.$CheckExistingVoucherCode = 'read/CheckExistingVoucherCode'
Vue.prototype.$GetValueDashboardPositivenegative = 'read/GetValueDashboardPositiveNegative'
Vue.prototype.$GetListCountriesById = 'read/GetListCountriesById'
Vue.prototype.$GetTotalTodayVisitor = 'read/GetTotalTodayVisitor'
Vue.prototype.$GetLastWeekVisits = 'read/GetLastWeekVisits'
Vue.prototype.$GetLastMonthVisits = 'read/GetLastMonthVisits'
Vue.prototype.$GetMonthlyChartData = 'read/GetMonthlyChartData'
Vue.prototype.$GetListLanguages = 'read/GetListLanguages'
Vue.prototype.$GetFeatures = 'read/GetFeatures'
Vue.prototype.$GetListUserAccess = 'read/GetListUserAccess'
Vue.prototype.$GetThisWeekVisits = 'read/GetThisWeekVisits'
Vue.prototype.$GetListPositionCompany = 'read/GetListPositionCompany'
Vue.prototype.$GetDocDetails = 'read/GetDocDetails'
Vue.prototype.$GetListFeature = 'read/GetListFeatures'
Vue.prototype.$GetFeaturesByUserId = 'read/GetFeaturesByUserId'
Vue.prototype.$GetSessionUrlCandidate = 'read/GetSessionUrlCandidate'
Vue.prototype.$GetCheckSubscriptionValidDate = 'read/GetCheckSubscriptionValidDate'
Vue.prototype.$GetListTypeUserVoucher = 'read/GetListTypeUserVoucher'
Vue.prototype.$GetVoucherByVoucherId = 'read/GetVoucherByVoucherId'
Vue.prototype.$GetCheckCompanyView = 'read/GetCheckCompanyView'
Vue.prototype.$GetListControlVoucher = 'read/GetListControlVoucher'
Vue.prototype.$GetListIndustries = 'read/GetListIndustries'
Vue.prototype.$GetListProduct = 'kiddo/read/GetListProduct'
Vue.prototype.$GetListProductById = 'kiddo/read/GetListProductById'
Vue.prototype.$GetParentByUserId = 'kiddo/read/GetParentByUserId'
Vue.prototype.$GradeListAuthorize = 'kiddo/Read/GradeListAuthorize'
Vue.prototype.$ExamListAuthorize = 'kiddo/Read/ExamListAuthorize'
Vue.prototype.$SubjectListAuthorize = 'kiddo/Read/SubjectListAuthorize'
Vue.prototype.$GetExamCountry = 'kiddo/Read/GetExamCountry'
Vue.prototype.$ListSubjectByCountryId = 'kiddo/Read/SubjectListByCountryId'
Vue.prototype.$GetListGradePackage = 'kiddo/Read/GetListGradeProduct'
Vue.prototype.$GetListSubGradePackage = 'kiddo/Read/GetListSubGradeProduct'
Vue.prototype.$GetUserBankDetails = 'kiddo/Read/GetUserBankDetails'
Vue.prototype.$GetListTotalRegisterByUserId = 'kiddo/Read/GetListTotalRegisterByUserId'
Vue.prototype.$GetListTransactionUserId = 'kiddo/read/GetListTransactionUserId'
Vue.prototype.$GetTotalAmountUserId = 'kiddo/read/GetTotalAmountUserId'


Vue.prototype.$DeleteCompanyQuestionCodeById = 'delete/DeleteCompanyQuestionCodeById'
Vue.prototype.$DeleteCompanyQuestion = 'delete/DeleteCompanyQuestion'
Vue.prototype.$DeleteBlogPost = 'delete/DeleteBlogPost'
Vue.prototype.$DeleteDocument = 'delete/DeleteDocument'
Vue.prototype.$DeleteVoucher = 'delete/DeleteVoucher'


Vue.prototype.$SignUp = 'Insert/Register'
Vue.prototype.$LoginTokenWeb = 'kiddo/Insert/LoginTokenWeb'
// === Language state ===
export const langState = Vue.observable({
  currentLang: 'bm' // default
})

export function setLanguage(lang) {
  langState.currentLang = lang
  localStorage.setItem('preferredLang', lang)
}

// Load preferred language on startup
const savedLang = localStorage.getItem('preferredLang')
if (savedLang) langState.currentLang = savedLang

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App,
    PulseLoader,
  }
})
